/*
 * Click & collect: wiring for snippets/cart-fulfilment.liquid.
 * Decisions live in cart-fulfilment-logic.js and cart-fulfilment-days.js (unit-tested);
 * this file only reads the page, saves cart attributes and shows the result.
 *
 * Never lock a customer out of paying:
 *  - if this script never runs, checkout stays enabled (orders that slip through are
 *    flagged in the TMS);
 *  - if Bird's delivery date widget never renders, delivery needs only the tick.
 *
 * The basket drawer and /cart replace parts of their HTML on every basket change, so
 * each [data-fulfilment] root is treated as disposable: its observers stop as soon as
 * it is detached, and a fresh root re-reads everything from the cart attributes.
 */
(function () {
  if (window.__cartFulfilment) return;
  window.__cartFulfilment = true;

  var L = window.CartFulfilmentLogic;
  var D = window.CartFulfilmentDays;
  if (!L || !D) return;

  var BIRD_WAIT_MS = 8000;
  var DAY_LABEL = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
  var MESSAGES = { date: 'Please choose a date.', collectionDate: 'Please choose a collection day.', terms: 'Please tick to agree to the terms.' };

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-fulfilment]')).filter(function (r) { return r.isConnected; });
  }
  function state(root) { return root.__cf || (root.__cf = { moves: 0, birdMissing: false, canCheckout: true }); }
  function scopeOf(root) { return root.closest('form') || root.parentElement || document; }
  function buttonsIn(scope) { return Array.prototype.slice.call(scope.querySelectorAll('[name="checkout"]')); }
  function items(root) {
    try { return JSON.parse(root.querySelector('[data-fulfilment-items]').textContent); } catch (e) { return []; }
  }
  function modeOf(root) { return L.normaliseMode(root.dataset.mode); }
  function daySelect(root) { return root.querySelector('[data-collection-day]'); }
  function tickOf(root) { return root.querySelector('[data-fulfilment-tick]'); }
  function birdMount(root) { return root.querySelector('[data-bird-slot] #birdchime-slots-box'); }
  function termsDrawer(root, handle) {
    var local = root.parentElement && root.parentElement.querySelector('[data-terms-drawer="' + handle + '"]');
    return local || document.querySelector('[data-terms-drawer="' + handle + '"]');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function save(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (r) { return r.json(); });
  }

  // Fill the collection day list. Returns true when the saved day is no longer offered
  // (e.g. last week's), so the caller clears it instead of letting it pass the gate.
  function fillDays(root) {
    var select = daySelect(root);
    if (!select || select.options.length > 1) return false;
    var bh = String(root.dataset.bankHolidays || '').split(/[\s,]+/).filter(Boolean);
    var chosen = root.dataset.collectionDate || '';
    var matched = false;
    D.collectionDays(D.ukTodayIso(new Date()), bh).forEach(function (iso) {
      var opt = document.createElement('option');
      opt.value = iso;
      opt.textContent = DAY_LABEL.format(new Date(iso + 'T12:00:00Z'));
      if (chosen && L.birdDate(iso) === chosen) { opt.selected = true; matched = true; }
      select.appendChild(opt);
    });
    return Boolean(chosen) && !matched;
  }

  // For a collection, the day on screen is what counts (never a stale saved one).
  function effectiveAttributes(root, attributes) {
    var a = {};
    for (var k in attributes) if (Object.prototype.hasOwnProperty.call(attributes, k)) a[k] = attributes[k];
    if (modeOf(root) === 'Collection') {
      var select = daySelect(root);
      a['Collection Date'] = select && select.value ? L.birdDate(select.value) : '';
    }
    return a;
  }

  // Keep Bird's delivery date widget inside the Delivery panel. Bird's newer SDK moves its
  // mount next to the checkout buttons; move it back (capped, so we never fight Bird in a
  // loop). Wherever it ends up, it is hidden while Collect is chosen.
  function placeBird(root) {
    if (!root.isConnected) return;
    var slot = root.querySelector('[data-bird-slot]');
    var st = state(root);
    var mode = modeOf(root);
    Array.prototype.slice.call(scopeOf(root).querySelectorAll('#birdchime-slots-box')).forEach(function (m) {
      if (slot && !slot.contains(m) && st.moves < 5) { st.moves++; slot.appendChild(m); }
      if (!slot || !slot.contains(m)) m.hidden = mode === 'Collection';
    });
  }

  function render(root, attributes) {
    if (!root.isConnected) return;
    var st = state(root);
    st.slot = attributes._BirdChimeSlotId || '';
    var mode = modeOf(root);
    var tick = tickOf(root);
    var s = L.cartFulfilmentState({
      items: items(root), mode: mode, attributes: effectiveAttributes(root, attributes),
      ticked: Boolean(tick && tick.checked), deliveryDateOptional: st.birdMissing,
    });

    root.querySelectorAll('[data-fulfilment-panel]').forEach(function (el) { el.hidden = el.dataset.fulfilmentPanel !== mode; });
    root.querySelectorAll('[data-tick-text]').forEach(function (el) { el.hidden = el.dataset.tickText !== mode; });
    root.querySelectorAll('[data-pickup-reminder]').forEach(function (el) { el.hidden = mode !== 'Collection'; });
    root.querySelectorAll('[data-fulfilment-choice]').forEach(function (b) {
      var on = b.dataset.fulfilmentChoice === mode;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    placeBird(root);
    syncBirdVisibility();

    // Two links under the one tick: the mode's terms (swapped with the mode) and the
    // standard terms (fixed). Each hides when its panel didn't render (empty page/policy).
    root.querySelectorAll('[data-terms-open]').forEach(function (link) {
      if (link.hasAttribute('data-terms-mode')) link.dataset.termsOpen = L.termsHandle(mode);
      link.hidden = !termsDrawer(root, link.dataset.termsOpen);
    });
    root.querySelectorAll('[data-terms-label]').forEach(function (el) { el.hidden = el.dataset.termsLabel !== mode; });
    syncNoteHints(scopeOf(root), mode);
    var w = root.querySelector('[data-weight]');
    if (w) {
      var t = L.weightText(Number(root.dataset.totalGrams), root.dataset.weightless === 'true');
      w.textContent = t ? '(' + t + ')' : '';
    }

    st.canCheckout = s.canCheckout;
    buttonsIn(scopeOf(root)).forEach(function (btn) {
      btn.setAttribute('data-fulfilment-gated', '');
      btn.disabled = !s.canCheckout;
      holdGate(btn);
    });
    var msg = root.querySelector('[data-fulfilment-missing]');
    if (msg) {
      var first = s.missing[0];
      msg.textContent = first === 'date' ? (mode === 'Collection' ? MESSAGES.collectionDate : MESSAGES.date) : first ? MESSAGES.terms : '';
      msg.hidden = s.canCheckout;
    }
  }

  // The basket root that gates this checkout button, if any (same form, or the page).
  function gateRootOf(btn) {
    var scope = btn.closest('form') || document;
    return roots().filter(function (r) { return scope.contains(r); })[0] || null;
  }
  function gated(btn) {
    var root = gateRootOf(btn);
    return Boolean(root && !state(root).canCheckout);
  }

  // Live's legacy Bird widget (cdn.birdchime.com/script.js) re-enables every checkout
  // button a few seconds after load, which would let a delivery basket through with no
  // date or tick (seen on a live preview, 19 Oct). Put our state back whenever anything
  // else changes it. Only writes when the value differs, so it never loops with Bird.
  function holdGate(btn) {
    if (btn.__cfHold || !window.MutationObserver) return;
    btn.__cfHold = new MutationObserver(function () {
      if (!btn.isConnected) { btn.__cfHold.disconnect(); return; }
      var shouldDisable = gated(btn);
      if (btn.disabled !== shouldDisable) btn.disabled = shouldDisable;
    });
    btn.__cfHold.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
  }

  // Release any checkout button we gated whose form no longer holds a root (the basket
  // became samples-only, or was emptied).
  function releaseOrphanButtons() {
    document.querySelectorAll('[name="checkout"][data-fulfilment-gated]').forEach(function (btn) {
      var scope = btn.closest('form') || document;
      if (!scope.querySelector('[data-fulfilment]')) btn.disabled = false;
    });
  }

  // ----- Order notes box (snippets/cart-note.liquid) -----
  // Always open, just above the checkout button (Suzie 2 Oct). The theme's own note
  // field (name="note") still travels with the cart form when it is submitted. On top of
  // that we save it as it is typed, because the drawer redraws the box from the saved
  // cart note on every basket change, which would otherwise wipe unsaved typing.
  var NOTE_SAVE_MS = 600;
  var noteDraft = null;
  var noteTimer = null;
  var noteSaveInFlight = null;
  function noteBoxes() { return Array.prototype.slice.call(document.querySelectorAll('textarea[data-cart-note-input]')); }
  function saveNote() {
    clearTimeout(noteTimer);
    if (noteDraft === null) return Promise.resolve();
    if (noteSaveInFlight) return noteSaveInFlight;
    var sentNote = noteDraft;
    noteSaveInFlight = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: sentNote }),
    }).catch(function () { /* the form submit still carries the note */ }).then(function () {
      noteSaveInFlight = null;
      // Only one write at a time; coalesce edits made during it into the latest note.
      if (noteDraft !== sentNote) return saveNote();
    });
    return noteSaveInFlight;
  }
  // A redrawn box shows the saved note; put back what the customer typed since.
  function restoreNotes() {
    noteBoxes().forEach(function (box) {
      var v = L.noteToRestore(noteDraft, box.value);
      if (v !== null && box !== document.activeElement) box.value = v;
    });
  }
  // "Someone else collecting?" shows above the box only when Collect is chosen.
  function syncNoteHints(scope, mode) {
    scope.querySelectorAll('[data-cart-note-hint]').forEach(function (el) { el.hidden = el.dataset.cartNoteHint !== mode; });
  }
  // A form with no choice (samples only, or emptied) never shows a mode hint.
  function hideOrphanNoteHints() {
    document.querySelectorAll('[data-cart-note-hint]').forEach(function (el) {
      var scope = el.closest('form') || document;
      if (!scope.querySelector('[data-fulfilment]')) el.hidden = true;
    });
  }

  function refresh() {
    releaseOrphanButtons();
    hideOrphanNoteHints();
    restoreNotes();
    var rs = roots();
    if (!rs.length) return Promise.resolve();
    return getCart().then(function (cart) { rs.forEach(function (r) { render(r, cart.attributes || {}); }); });
  }

  function saveFor(root) {
    var tick = tickOf(root);
    var select = daySelect(root);
    return save(L.attributesForMode(modeOf(root), {
      ticked: Boolean(tick && tick.checked),
      collectionIso: select && select.value ? select.value : null,
      currentSlot: state(root).slot,
    })).then(function (cart) { roots().forEach(function (r) { render(r, cart.attributes || {}); }); });
  }

  // Bird's new SDK (test store) opens on its own Store Pickup tab. Delivery uses Bird for
  // the delivery date only, so point it at Shipping when that SDK is present. The live
  // store runs Bird's legacy widget (no SDK), which is delivery-only already.
  function birdToShipping() {
    try {
      var sdk = window.BirdApp && window.BirdApp.sdk;
      if (sdk && typeof sdk.setMethod === 'function') sdk.setMethod('Shipping');
    } catch (e) { /* Bird is optional here */ }
  }

  // Delivery uses Bird's Shipping mode only. Bird's newer SDK (test store) re-mounts on
  // its default Store Pickup tab after every basket re-render, and its tabs are hidden in
  // our panel, so switch it back whenever it is not on Shipping. Clicking a hidden tab
  // works; the check makes it a no-op once Bird is on Shipping (no loop).
  function ensureBirdShipping(root) {
    if (!root.isConnected || modeOf(root) !== 'Delivery') return;
    var m = birdMount(root);
    if (!m) return;
    var tabs = Array.prototype.slice.call(m.querySelectorAll('.bird-method-tab'));
    if (!tabs.length) return;
    var ship = tabs.filter(function (t) { return /shipping/i.test(t.textContent); })[0];
    if (ship && ship.getAttribute('aria-selected') !== 'true') ship.click();
  }

  // Bird's newer SDK (test store) validates the cart form itself and blocks checkout,
  // scrolling to its widget, until it holds a delivery date. A hidden widget is not
  // validated. So Bird is hidden whenever it has nothing to do: Collect (our own day
  // list), or when its widget never rendered (the tick-only fallback). In Delivery the
  // customer picks Bird's date, which satisfies Bird's check. Live's legacy widget has
  // no SDK; its checkout blocking is switched off in the Bird admin at launch.
  // Bird is one widget per page, so one block decides: the cart page's when present
  // (the drawer's copy can linger there on the test store), otherwise the drawer's.
  var birdHidden = null;
  function syncBirdVisibility() {
    var rs = roots();
    var root = rs.filter(function (r) { return r.closest('#main'); })[0] || rs[0];
    if (!root) return;
    try {
      var sdk = window.BirdApp && window.BirdApp.sdk;
      if (!sdk || typeof sdk.setHidden !== 'function') return;
      var hide = modeOf(root) === 'Collection' || state(root).birdMissing;
      if (birdHidden === hide) return;
      birdHidden = hide;
      sdk.setHidden(hide);
      // Hiding/showing makes Bird re-save its own cached copy of the cart attributes,
      // which can wipe ours (Fulfilment, the collection day, the pickup slot). Re-save if it did.
      setTimeout(function () {
        if (!root.isConnected) return;
        getCart().then(function (c) {
          var a = c.attributes || {};
          var select = daySelect(root);
          var wantDay = modeOf(root) === 'Collection' && select && select.value ? L.birdDate(select.value) : '';
          var slotWrong = modeOf(root) === 'Collection' ? !L.isOurPickupSlot(a._BirdChimeSlotId) : L.isOurPickupSlot(a._BirdChimeSlotId);
          if (a.Fulfilment !== modeOf(root) || (a['Collection Date'] || '') !== wantDay || slotWrong) { state(root).slot = a._BirdChimeSlotId || ''; saveFor(root); }
        });
      }, 1500);
    } catch (e) { /* Bird is optional here */ }
  }

  function birdRendered(root) {
    var m = birdMount(root);
    return Boolean(m && (m.children.length || m.textContent.trim()));
  }

  // Bird's newer SDK (test store) does not re-mount into a mount that a basket
  // re-render replaced, nor reliably when it is shown again after Collect; ask it to.
  // Live's legacy widget re-mounts via data-watch-ajax. On /cart the newer SDK has no
  // mount of its own (its cart-page selector isn't set); mount it into our Delivery panel.
  function ensureBirdMounted(root) {
    setTimeout(function () {
      if (!root.isConnected || modeOf(root) !== 'Delivery' || birdRendered(root)) return;
      try {
        var w = window.BirdApp && window.BirdApp.widget;
        var m = birdMount(root);
        if (w && typeof w.mount === 'function' && m) w.mount(m);
        else if (w && typeof w.remount === 'function') w.remount();
      } catch (e) { /* Bird is optional here */ }
    }, 1500);
  }

  function init(root) {
    var st = state(root);
    if (st.init) return;
    st.init = true;
    if (fillDays(root) && modeOf(root) === 'Collection') saveFor(root);
    if (modeOf(root) === 'Delivery') birdToShipping();
    placeBird(root);
    ensureBirdShipping(root);

    ensureBirdMounted(root);

    // If Bird's widget never shows, don't hold delivery customers hostage to it.
    st.birdTimer = setTimeout(function () {
      if (!root.isConnected) return;
      if (!birdRendered(root)) { st.birdMissing = true; refresh(); }
    }, BIRD_WAIT_MS);

    // Bird writes the delivery date to the cart asynchronously; re-read after its widget
    // changes. Watch the form so a widget Bird moved elsewhere is still seen. The
    // observer stops for good once this root is replaced by a re-render.
    if (window.MutationObserver) {
      var t = null;
      st.observer = new MutationObserver(function (records) {
        if (!root.isConnected) {
          st.observer.disconnect();
          clearTimeout(t);
          clearTimeout(st.birdTimer);
          return;
        }
        var birdChanged = records.some(function (r) {
          var n = r.target.nodeType === 1 ? r.target : r.target.parentElement;
          return n && n.closest && n.closest('#birdchime-slots-box, [data-bird-slot]');
        });
        if (!birdChanged) return;
        clearTimeout(t);
        t = setTimeout(function () {
          if (!root.isConnected) return;
          if (birdRendered(root)) st.birdMissing = false;
          placeBird(root);
          ensureBirdShipping(root);
          refresh();
        }, 600);
      });
      st.observer.observe(scopeOf(root), { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'value', 'aria-selected'] });
    }
  }

  function openTerms(root, handle, opener) {
    var d = termsDrawer(root, handle);
    if (!d) return;
    // On /cart the sticky header stacks above anything inside the page, so the panel
    // moves to <body>. In the basket drawer it stays inside the drawer, within the
    // drawer's focus trap and scroll lock.
    if (!root.closest('.quick-cart') && d.parentElement !== document.body) {
      document.querySelectorAll('body > [data-terms-drawer="' + handle + '"]').forEach(function (x) { if (x !== d) x.remove(); });
      document.body.appendChild(d);
    }
    d.hidden = false;
    d.__returnFocus = opener;
    var panel = d.querySelector('.terms-drawer__panel');
    if (panel) panel.focus();
  }
  function closeTerms(d) {
    d.hidden = true;
    if (d.__returnFocus && d.__returnFocus.isConnected) d.__returnFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var choice = e.target.closest('[data-fulfilment-choice]');
    if (choice) {
      var root = choice.closest('[data-fulfilment]');
      if (!root || choice.dataset.fulfilmentChoice === root.dataset.mode) return;
      root.dataset.mode = L.normaliseMode(choice.dataset.fulfilmentChoice);
      var tick = tickOf(root);
      if (tick) tick.checked = false;
      render(root, {});
      // Save ours first, then point Bird at Shipping: Bird saves its own cached copy of
      // the cart attributes, which can put an older Fulfilment back. Re-save if it did.
      var wanted = root.dataset.mode;
      saveFor(root).then(function () {
        if (wanted !== 'Delivery' || !(window.BirdApp && window.BirdApp.sdk)) return;
        birdToShipping();
        ensureBirdMounted(root);
        setTimeout(function () {
          if (!root.isConnected) return;
          getCart().then(function (c) {
            if ((c.attributes || {}).Fulfilment !== wanted && root.dataset.mode === wanted) saveFor(root);
          });
        }, 1500);
      });
      return;
    }
    var open = e.target.closest('[data-terms-open]');
    if (open) {
      var r = open.closest('[data-fulfilment]');
      if (r) openTerms(r, open.dataset.termsOpen, open);
      return;
    }
    if (e.target.closest('[data-terms-close]')) closeTerms(e.target.closest('[data-terms-drawer]'));
  });

  // Back from checkout (page restored from the back/forward cache): re-apply Bird's visibility.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { birdHidden = null; syncBirdVisibility(); }
  });

  // Arrow keys move between Delivery and Collect (radio group behaviour).
  document.addEventListener('keydown', function (e) {
    var choice = e.target.closest && e.target.closest('[data-fulfilment-choice]');
    if (!choice || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
    var group = Array.prototype.slice.call(choice.parentElement.querySelectorAll('[data-fulfilment-choice]'));
    var next = group[(group.indexOf(choice) + 1) % group.length];
    e.preventDefault();
    next.focus();
    next.click();
  });

  // Escape closes the terms panel only, not the basket drawer behind it.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('[data-terms-drawer]:not([hidden])');
    if (!open.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open.forEach(closeTerms);
  }, true);

  // The basket page also renders the drawer, so two note boxes can be on screen at
  // once: keep the other one in step so neither saves a stale note over the other.
  function syncNoteBoxes(source) {
    noteBoxes().forEach(function (box) {
      if (box !== source) box.value = noteDraft;
    });
  }

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('textarea[data-cart-note-input]')) return;
    noteDraft = e.target.value;
    syncNoteBoxes(e.target);
    clearTimeout(noteTimer);
    noteTimer = setTimeout(saveNote, NOTE_SAVE_MS);
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('textarea[data-cart-note-input]')) {
      noteDraft = e.target.value;
      syncNoteBoxes(e.target);
      saveNote();
      return;
    }
    var root = e.target.closest('[data-fulfilment]');
    if (!root) return;
    if (e.target.matches('[data-fulfilment-tick]') || e.target.matches('[data-collection-day]')) saveFor(root);
  });

  // A gated checkout click goes nowhere, even if another script enabled the button or
  // handles the click itself (window + capture: runs before any document listener).
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"][data-fulfilment-gated]');
    if (!btn || !gated(btn)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.disabled = true;
    refresh();
  }, true);

  // Checkout: stop it if the basket isn't ready; otherwise re-save our attributes first
  // (another app may have written an older copy of them since), then continue once.
  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    var form = e.target;
    if (!submitter || submitter.name !== 'checkout') return;
    var root = roots().filter(function (r) { return form.contains(r); })[0];
    if (!root && noteDraft === null) return;
    if (form.__cfSynced) { form.__cfSynced = false; return; }
    e.preventDefault();
    if (form.__cfInFlight) return;
    if (root && !state(root).canCheckout) { refresh(); return; }
    form.__cfInFlight = true;
    // Drain note writes before submitting, including samples-only carts. Otherwise
    // an older autosave could overwrite the note carried by the checkout form.
    Promise.all([root ? saveFor(root).catch(function () {}) : Promise.resolve(), saveNote()]).then(function () {
      form.__cfInFlight = false;
      form.__cfSynced = true;
      try {
        if (form.requestSubmit && submitter.isConnected) { form.requestSubmit(submitter); return; }
      } catch (err) { /* fall through to a plain submit */ }
      form.__cfSynced = false;
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
      form.appendChild(h);
      form.submit();
    });
  }, true);

  // The drawer and /cart replace their HTML on every basket change: pick up new roots.
  var pending = null;
  function scan() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      roots().forEach(init);
      refresh();
    }, 150);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = Array.prototype.slice.call(records[i].addedNodes).concat(Array.prototype.slice.call(records[i].removedNodes));
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('[data-fulfilment], [name="checkout"], [data-cart-note-input]') || n.querySelector('[data-fulfilment], [name="checkout"], [data-cart-note-input]')) { restoreNotes(); scan(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('cart:updated', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
